module.exports = __webpack_public_path__ + "images/emoji/bathtub.d3019ae78386c429c3f3.png";